/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Point the org's future uploads at another of its tenant pools.
 */
export interface TalentPoolUploadDestinationRequest {
  talent_pool_id: string;
}
